import { render, staticRenderFns } from "./AddRules.vue?vue&type=template&id=426eb400&"
import script from "./AddRules.vue?vue&type=script&lang=js&"
export * from "./AddRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports